import React from "react";
import { RotaButton, iconNew } from "@teamrota/rota-design";
import { useTheme } from "styled-components";

import {
  StyledPopupBackground,
  StyledPopupContainer,
  StyledCloseButton,
  StyledTitle,
  StyledContent,
  StyledButtonsContainer
} from "./index.styles";

const { Tick } = iconNew;

const PredictedShiftPopup = ({ onClose, onSave }) => {
  const theme = useTheme();

  return (
    <StyledPopupBackground onClick={onClose}>
      <StyledPopupContainer onClick={e => e.stopPropagation()}>
        <StyledCloseButton onClick={onClose} icon={"close"} />
        <Tick color={theme.success.main} />
        <StyledTitle>Predicted shift</StyledTitle>
        <StyledContent>
          Predicted shifts are special shifts that allow you to anticipate
          rosters ahead of time. When requests come in from an external provider
          like ShiftStream or Email, the predicted shift is used as the first
          source of candidates for the algorithm.
        </StyledContent>
        <StyledButtonsContainer>
          <RotaButton onClick={() => onClose()} variant={"outlined"}>
            Cancel
          </RotaButton>
          <RotaButton onClick={() => onSave()}>Save</RotaButton>
        </StyledButtonsContainer>
      </StyledPopupContainer>
    </StyledPopupBackground>
  );
};

export default PredictedShiftPopup;
